import {DTConditionNode} from 'common/src/modules/decisionTree/decisionTree.types';
import {SETUP_AGENT_STORAGE_PREFIX} from '../../promptToCardAgentV2.consts';

export default function getCardFromState<T extends DTConditionNode>(): T {
  const card = sessionStorage.getItem(SETUP_AGENT_STORAGE_PREFIX);

  if (!card) {
    throw new Error('Card was not found in state');
  }

  return JSON.parse(card) as T;
}
